import { useEffect, useState } from 'preact/hooks'
import { EVENT_ACTIONS, EVENT_CATEGORY, OBSERVER_CONFIG } from './analytics.constants'
import { buildLabelObject } from './analytics.utils'
import { logEvent } from './logger'

export const useAnalytics = (
    postsNum: number,
    ref: HTMLDivElement,
    embedName: string,
    withImages: boolean,
    experiment?: string,
): { onLinkClick: (url: string, index: number) => void } => {
    const [componentPlacement, setComponentPlacement] = useState('')

    useEffect(() => {
        const article = document.querySelector('article')
        if (postsNum > 0 && ref && article) {
            setComponentPlacement((ref.offsetTop / article?.scrollHeight).toFixed(1))
        }
    }, [postsNum, ref])

    useEffect(() => {
        if (postsNum > 0 && componentPlacement) {
            window.mmClientApi = window.mmClientApi || []
            window.mmClientApi.push('analytics', {
                event_category: EVENT_CATEGORY,
                event_action: EVENT_ACTIONS.EMBED,
                event_label: buildLabelObject(embedName, componentPlacement, postsNum, withImages),
            })
            logEvent({ name: 'widget_rendered', experiment })
        }
    }, [postsNum, embedName, componentPlacement, postsNum, withImages])

    useEffect(() => {
        if (ref && postsNum > 0 && componentPlacement && embedName) {
            const ob = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    window.mmClientApi = window.mmClientApi || []
                    window.mmClientApi.push('analytics', {
                        event_category: EVENT_CATEGORY,
                        event_action: EVENT_ACTIONS.VIEWABLE,
                        event_label: buildLabelObject(embedName, componentPlacement, postsNum, withImages),
                    })
                    logEvent({ name: 'widget_viewable', experiment })
                    ob.disconnect()
                }
            }, OBSERVER_CONFIG)
            ob.observe(ref)
        }
    }, [ref, embedName, componentPlacement, postsNum])

    const onLinkClick = (url: string, index: number) => {
        window.mmClientApi = window.mmClientApi || []
        window.mmClientApi.push('analytics', {
            event_category: EVENT_CATEGORY,
            event_action: EVENT_ACTIONS.CLICK,
            event_label: buildLabelObject(embedName, componentPlacement, postsNum, withImages, index + 1, url),
        })
        logEvent({ name: 'article_click', experiment })
    }

    return { onLinkClick }
}
